// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6c97b803","938":"f1e700a9"}[chunkId] + ".chunk.js";
};